import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'z-form-status',
  templateUrl: './form-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormStatusComponent implements OnInit, OnChanges, OnDestroy {
  destroy$ = new Subject<void>();

  @Input() form: FormGroup;
  @Input() styleClass: string;

  @Input() label: string;
  @Input() title: string;

  label$ = new BehaviorSubject<string>(null);
  title$ = new BehaviorSubject<string>(null);

  display$ = new BehaviorSubject<boolean>(false);

  translate = (key: string | string[], params?: Record<string, string>, lang?: string) =>
    this.translocoService.translate(key, params, lang);

  constructor(private translocoService: TranslocoService) {}

  ngOnInit() {
    this.translocoService
      .selectTranslation()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.form.statusChanges.pipe(takeUntil(this.destroy$)).subscribe((status) => {
          if (status === 'INVALID') {
            this.display$.next(true);
          } else {
            this.display$.next(false);
          }

          if (!this.label) {
            this.label$.next(this.translate('core.components.form_status.invalid.label'));
          } else {
            this.label$.next(this.label);
          }

          if (!this.title) {
            this.title$.next(this.translate('core.components.form_status.invalid.title'));
          } else {
            this.title$.next(this.title);
          }
        });
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.label && !!changes.label.currentValue) {
      this.title$.next(changes.label.currentValue);
    }

    if (changes.title && !!changes.title.currentValue) {
      this.title$.next(changes.title.currentValue);
    }
  }
}
